import gsap from "gsap"
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CubicBezier } from '../config/global'
import FoldOnLoad from './foldOnLoad'

export default class PageLoader {
  constructor() {
    this.getDomElements()

    if (!this.dom.pageloader || !this.dom.loaderScreen || !this.dom.loaderLogo || !this.dom.headerLogo) return

    gsap.registerPlugin(ScrollTrigger);
  }

  addAnimation() {

    this.dom.pageloader.classList.add('is-active')

    // Reset
    if (this.dom.statusBar) {
      this.dom.statusBar.classList.remove('is-active')
    }

    this.dom.header.classList.remove('is-active')

    //Swipe in the background
    return gsap.fromTo(this.dom.loaderScreen, {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.75,
      ease: CubicBezier,
      onComplete: () => {
        document.body.style.overflow = 'hidden'

        // Lock scroll at top
        setTimeout(() => {
          window.scrollTo(0,0);
        }, 1);
      }
    })
  }


  removeAnimation() {
    // Create our remove timeline and reset the logo
    const removeTimeline = gsap.timeline()
    this.dom.loaderLogo.style.display = 'block'

    // Get the position of the header logo
    const headerLogoPosition = this.dom.headerLogo.getBoundingClientRect()
    const headerLogoWidth = this.dom.headerLogo.scrollWidth
    const headerLogoHeight = this.dom.headerLogo.scrollHeight

    // Lock scroll at top
    document.body.style.overflow = 'hidden'

    // Load the logo in
    removeTimeline.fromTo(this.dom.loaderLogo, {
      opacity: 0,
      width: 0,
      height: 0,
      top: '50%',
      left: '50%'
    },
    {
      opacity: 1,
      width: headerLogoWidth * 2,
      height: headerLogoHeight * 2,
      duration: 0.75,
      ease: CubicBezier,
    })

    // Animate out the logo
    removeTimeline.add().to(this.dom.loaderLogo, {
      left: headerLogoPosition.left,
      top: headerLogoPosition.top,
      yPercent: 0,
      xPercent: 0,
      width: headerLogoWidth,
      height: headerLogoHeight,
      duration: 1,
      ease: CubicBezier,
      onStart: () => {
        setTimeout(() => {
          this.dom.pageloader.classList.remove('is-active')
          new FoldOnLoad
        }, 800);

        setTimeout(() => {
          this.dom.loaderLogo.style.opacity = 0
        }, 750);
      }
    })


    //Swipe away the background
    removeTimeline.add().fromTo(this.dom.loaderScreen, {
      opacity: 1,
    },
    {
      opacity: 0,
      duration: 1,
      delay: -0.5,
      ease: CubicBezier,
      onComplete: () => {
        document.body.style.overflow = 'visible'
      }
    })
  }


  minimalAnimation() {
    if (this.dom.statusBar) {
      this.dom.statusBar.classList.remove('is-active')
    }

    this.dom.header.classList.remove('is-active')
    this.dom.body.dataset.theme = 'light'

    setTimeout(() => {
      new FoldOnLoad
    }, 350)

    //Swipe in the background
    return gsap.to(this.dom.loaderScreen,
    {
      opacity: 0,
      duration: 0.75,
      ease: CubicBezier,
      onComplete: () => {
        ScrollTrigger.refresh(true)
        this.dom.pageloader.classList.remove('is-active')
        document.body.style.overflow = 'visible'
      }
    })
  }


  getDomElements() {
    this.dom = {
      'pageloader': document.querySelector('.js-pageloader'),
      'loaderScreen': document.querySelector('.js-loader-screen'),
      'loaderLogo': document.querySelector('.js-loader-logo'),
      'headerLogo': document.querySelector('.js-header-logo'),
      'header': document.querySelector('.js-header'),
      'statusBar': document.querySelector('.js-status-bar'),
      'body': document.querySelector('body'),
    }
  }
}
